<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      require: true,
      default: false,
    },
    item: {
      type: Object,
      require: true,
      default: () => {},
    },
    isHealthVault: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  methods: {
    closeDialog(action) {
      this.$emit('closeRevokeDialog', action)
      this.$emit('update:dialog', false)
    },
  },
}
</script>

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="280" persistent>
      <v-card>
        <v-card-title :class="$style.confirmText">
          Are you sure you want to revoke access for
          {{ isHealthVault ? item.recipient_name : item.sender_name }}?
        </v-card-title>

        <v-card-actions class="mx-auto mt-4 pt-0">
          <div>
            <v-btn
              color="#0476D9"
              text
              :class="$style.txtBtn"
              @click="closeDialog('no')"
            >
              Cancel
            </v-btn>

            |

            <v-btn
              color="#0476D9"
              text
              :class="[$style.txtBtn, $style.bold]"
              @click="closeDialog('yes')"
            >
              Yes,proceed
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';

.txtBtn {
  padding: 0 !important;
  font-size: 14px !important;
  color: #0476d9 !important;
  text-transform: none;
  background: none !important;
  border: none;
  box-shadow: none !important;
}

.bold {
  font-weight: 700;
}
.confirmText {
  font-size: 14px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 150%;
  word-break: keep-all !important;
  word-wrap: normal !important;
}
</style>
